import { render, staticRenderFns } from "./addlocpoint.vue?vue&type=template&id=ffcaa2be&scoped=true"
import script from "./addlocpoint.vue?vue&type=script&lang=js"
export * from "./addlocpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcaa2be",
  null
  
)

export default component.exports